import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';

import Sidebar from '../Sidebar/Sidebar';
import appContext from '../../context/App';
import WMLogo from '../../assets/images/logo-wm.png';

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1
	},
	menuButton: {
		marginRight: theme.spacing(2)
	},
	title: {
		flexGrow: 1
	},
}));

const Header = props => {
    const classes = useStyles();
	const [openDrawer, setOpenDrawer] = React.useState(false);
	const [headerTitle] = appContext.useAppContext();

	const toggleDrawer = (event) => {
		if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
			return;
		}
		setOpenDrawer(prevState => {
			return !prevState;
		});
	};

    return (
        <div className={classes.root}>
            <AppBar position="static" color={props.isAuthenticated ? 'primary' : 'default'}>
                <Toolbar>
                    { props.isAuthenticated ? <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu" onClick={toggleDrawer}>
                        <Icon>menu</Icon>
                    </IconButton> : null }

					{ !props.isAuthenticated ? <img src={WMLogo} alt="WM" style={{ maxWidth: '95px' }} /> : null }

                    <Typography variant="h6" color={!props.isAuthenticated ? 'primary' : 'initial'} className={classes.title} style={{ textAlign: !props.isAuthenticated ? 'center' : 'left', marginLeft: !props.isAuthenticated ? '-85px' : '0px' }}>
                        {headerTitle}
                    </Typography>
					{ props.isAuthenticated ? <IconButton edge="end" color="inherit" aria-label="reload" onClick={() => window.location.reload()}>
                        <Icon>replay</Icon>
                    </IconButton> : null }
                </Toolbar>
            </AppBar>
            
            { props.isAuthenticated ? <Sidebar open={openDrawer} onClose={toggleDrawer} /> : null }
        </div>
    )
}

export default Header;